/**
 * This is a list of feature flags that are used in Lab.
 *
 * Note: All feature flags are `false` by default
 * unless they are explicitly assigned to `true` in the respective variants in the LE Lab UI.
 *
 * Therefore, a good practice is to name the feature flags to reflect the default behaviour
 * e.g. `enable_lux_plus_feature` for the default behaviour of the feature being disabled.
 */
export enum LabFeatureFlags {
  // Add feature flags from Lab here
  enableHeroCarouselTakeover = 'enableHeroCarouselTakeover',
  enableTopBannerMessage = 'enableTopBannerMessage',
  enableSiteTakeover = 'enableSiteTakeover',
}
